<div class="container-fluid gx-5">
  <div class="card">
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'users-gear']"></fa-icon> {{selectedUserStory ? '[' +
          selectedUserStory.project_name + '] ' + selectedUserStory.title : ''}}
        </h3>
      </div>

      @if(selectedUserStory){
      <casi-user-story [showProjects]="true" [projectLabels]="projectLabels" [projects]="projects"
        [selectedUserStoryId]="selectedUserStoryId" [userStory]="selectedUserStory" [storyStatuses]="storyStatus"
        [storyTypes]="storyTypes" [storyPriorities]="storyPriorities" [storyEstimates]="storyEstimates" [users]="users"
        [modUsers]="projectUsers" [showCloseButton]="false">
      </casi-user-story>
      }


    </div>
  </div>


</div>
